import { render, staticRenderFns } from "./UserOpportunities.vue?vue&type=template&id=74a0864b&scoped=true&"
import script from "./UserOpportunities.vue?vue&type=script&lang=js&"
export * from "./UserOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./UserOpportunities.vue?vue&type=style&index=0&id=74a0864b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a0864b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardCard: require('/workspace/components/Dashboard/DashboardCard.vue').default})
